export const defaultReactiveJob = {
  Action: '',
  Address: '',
  AddressName: '',
  CallDescription: 'Please select a job',
  CallNo: '',
  CallerName: '',
  CallerPhoneNo: '',
  CallerReference: '',
  CompletedDatetime: '',
  ContractNotes: '',
  ContractNo: '',
  CriticalStatus: '4',
  CustomerCode: '',
  CustomerName: '',
  CustomerReference: '',
  EngineerName: '',
  FaultNotes: '',
  GeneralNotes: '',
  HoldReason: '',
  Priority: '',
  PriorityCode: '',
  NumberEngineers: 0,
  OnsiteReqdDatetime: '',
  Operator: '',
  ReceivedDatetime: '',
  RequiredDatetime: '',
  RepairNotes: '',
  RequiredDate: '',
  SerialNo: '',
  SLA: 'upcoming',
  SLAOnsite: 'upcoming',
  SLAComplete: 'upcoming',
  SLACompleteActual: '',
  SLACompleteActualTime: '',
  SLACompleteEstimated: '',
  SLACompleteEstimatedTime: '',
  SLAOnsiteActual: '',
  SLAOnsiteActualTime: '',
  SLAOnsiteEstimated: '',
  SLAOnsiteEstimatedTime: '',
  SLAOnsiteEstimatedDateTime: '',
  SLAOnsiteActualDateTime: '',
  SLACompleteEstimatedDateTime: '',
  SLACompleteActualDateTime: '',
  SOOrderNo: '',
  Date: '',
  Status: '',
  StatusCode: '',
  TypeCode: '',
  CallLocations: {
    CallLocation: {
      CallNo: '',
      ContractNo: '',
      LocationCode: '',
      LocationDesc: ''
    }
  },
  OrderedAmountExTax: 0.0,
};

export const defaultPlannedJob = {
  CUSTREF1: '',
  CUSTREF2: '',
  MODEL: '',
  VENDOR: '',
  YEARMAN: '',
  CallNo: 0,
  CallUnitSequence: 0,
  ContractNo: '',
  ContractSequenceNo: 0,
  ContractSiteDesc: '',
  CustomerCode: '',
  CustomerName: '',
  EngineerCode: '',
  EngineerName: '',
  InvoicedToDate: '',
  ItemCode: '',
  ItemDescription: 'Please select a job',
  MakeCode: '',
  Make: '',
  PMCallNo: 0,
  PMCallType: 0,
  PMEstHours: 0,
  Qty: '',
  Rate: 0,
  Reason: '',
  ReasonCode: '',
  Reseller: '',
  Routine: '',
  RoutineCode: '',
  RoutineDueDate: '',
  RoutineProcedure: '',
  RoutineProcedureCode: '',
  RoutineProcedureTaskText: '',
  Run: '',
  RunDueDate: '',
  RunNumber: 0,
  RunSequence: 0,
  ScuUserOnlyNum1: 0,
  ScuUserOnlyNum2: 0,
  SerialFlag: '',
  SerialLocationText: '',
  SerialNo: '',
  SerialStatusCode: 0,
  ServiceCentre: '',
  ServiceCentreCode: '',
  ServiceNo: '',
  ServicedQty: 0,
  Status: '',
  StatusCode: '',
  UniqueSequence: 0,
  UnitLocation: '',
  UnitLocationCode: '',
  UnitQty: 0,
};

export const appState = {
  currentPage: 'home',
  token: '',
  userId: '',
  name: '',
  selectedContract: '',
  selectedCustomerId: '',
  customerInfoMap: {},
  userPermissionsList: [],
  contractList: {},
  contractCriticalCode: {
    1: {
      CriticalCode: "PM1",
      Details: "Critical Risk",
      PriorityCode: 1,
    },
    2: {
      CriticalCode: "PM2",
      Details: "High Risk",
      PriorityCode: 2
    },
    3: {
      CriticalCode: "PM3",
      Details: "Medium Risk",
      PriorityCode: 3,
    },
    4: {
      CriticalCode: "PM4",
      Details: "Low Risk",
      PriorityCode: 4,
    },
    PM: {
      CriticalCode: "PM",
      Details: "Critical Risk",
      PriorityCode: "PM",
    },
    QU: {
      CriticalCode: "QU",
      Details: "Critical Risk",
      PriorityCode: "QU",
    }
  },
  contractDepartments: {},
  contractCallers: {},
  serviceCentreCode: '',
};

export const defaultAsset = {
  CesUserOnlyAlpha41: '',
  CesUserOnlyAlpha42: '',
  CesUserOnlyAlpha43: '',
  CesUserOnlyAlpha44: '',
  CesUserOnlyAlpha201: '',
  CesUserOnlyAlpha202: '',
  CesUserOnlyDate1: '',
  CesUserOnlyDate2: '',
  CesUserOnlyNum1: 0,
  CesUserOnlyNum2: 0,
  CesUserOnlyNum3: 0,
  CesUserOnlyNum4: 0,
  CUSTREF1: '',
  CUSTREF2: '',
  MODEL: '',
  VENDOR: '',
  YEARMAN: '',
  ChargeFlag: '',
  Condition: 0,
  ContractNo: '',
  ContractSequence: 0,
  ContractSiteDesc: '',
  ContractTypeCode: '',
  ContractUnitNextServices: '',
  CustomerCode: '',
  InvoiceAmount: 0,
  InvoiceNo: 0,
  InvoicedDate: '',
  InvoicedFromDate: '',
  InvoicedToDate: '',
  ItemCode: '',
  ItemDescription: '',
  Make: '',
  MakeCode: '',
  Rate: 0,
  SerialFlag: '',
  SerialInstallationDate: '',
  SerialLocationText: '',
  SerialNo: '',
  SerialStatusCode: '',
  SerialWarrantyDate: '',
  ServiceNo: '',
  UnitLocation: '',
  UnitLocationCode: '',
  UnitQty: 0,
};

export const defaultJobList = {
  currentPage: '',
  sortBy: '',
  openJobDetails: false,
  selectedReactiveJob: defaultReactiveJob,
  selectedPlannedJob: defaultPlannedJob,
  reactiveJobList: [],
  filteredReactiveJobList: [],
  plannedJobList: [],
  filteredPlannedJobList: [],
  filtersReactive: {
    periodFilter: '',
    slaFilters: [],
    priortiyFilters: [],
    statusFilters: [],
    buildingFilters: [],
    dateFilter: {},
  },
  filtersPlanned: {
    maintenanceFilter: [],
    statusFilter: [],
  },
  filtersSchedule: {
    ItemDescription: {},
    ContractNo: {},
  },
};

export const defaultAssetList = {
  currentPage: '',
  openAssetDetails: false,
  assetHistoryTab: '',
  sortBy: '',
  selectedAsset: {
    CesUserOnlyAlpha41: '',
    CesUserOnlyAlpha42: '',
    CesUserOnlyAlpha43: '',
    CesUserOnlyAlpha44: '',
    CesUserOnlyAlpha201: '',
    CesUserOnlyAlpha202: '',
    CesUserOnlyDate1: '',
    CesUserOnlyDate2: '',
    CesUserOnlyNum1: 0,
    CesUserOnlyNum2: 0,
    CesUserOnlyNum3: 0,
    CesUserOnlyNum4: 0,
    ChargeFlag: '',
    Condition: 0,
    ContractNo: '',
    ContractSequence: 0,
    ContractSiteDesc: '',
    ContractTypeCode: '',
    ContractUnitNextServices: '',
    CustomerCode: '',
    InvoiceAmount: 0,
    InvoiceNo: 0,
    InvoicedDate: '',
    InvoicedFromDate: '',
    InvoicedToDate: '',
    ItemCode: '',
    ItemDescription: '',
    Make: '',
    MakeCode: '',
    Rate: 0,
    SerialFlag: '',
    SerialInstallationDate: '',
    SerialLocationText: '',
    SerialNo: '',
    SerialStatusCode: '',
    SerialWarrantyDate: '',
    ServiceNo: '',
    UnitLocation: '',
    UnitLocationCode: '',
    UnitQty: 0,
  },

  assetList: [],
  filteredAssetList: [],
  assetFilters: {
    conditionFilter: -1,
    buildingFilter: [],
    underMaintenanceFilter: [],
  },
};
